
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";

  @Component({
    components: {
      CardBodyItem
    },
  })
  export default class CardBodyLink extends Vue {
    @Prop({ type: String, required: true }) readonly routeName!: string;
    @Prop({ type: String, required: true }) readonly value!: string;
    @Prop({ type: String, required: true }) readonly label!: string;
    @Prop({ type: Object, default: () => ({}) }) readonly routeParams!: Record<string, any>;
    @Prop({ type: Object, default: () => ({}) }) readonly routeQuery!: Record<string, any>;
  }
